import React from 'react'
import '../../../../assets/stylesheet/desktop.css';
import '../../../../assets/stylesheet/responsive.css';
import {  useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.css';
import cross from '../../../../assets/images/cross.svg';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import InputMask from 'react-input-mask';
import Select, { components } from 'react-select';

import { formatCanadianPhoneNumber } from "../../../../shared/helper.js";

const ViewSpecialInfoJSX = (props) => {

    const {
        specialInfoDetails, editSpecial, changeSpecialState, onDeleteButtonClick, wholeData,
        provinceList, handleChange, countryList, getSpecialization, subCategorySection
    } = props;
    const { t } = useTranslation();
    const {
        onInputChangeHandler, onOthersButtonClick
        , formError, onTouchHandler
    } = props;
    const isRequired = true
    const information = wholeData

    const newArrayOfObj = subCategorySection?.map(({
        name: label, institutionCategoryId: value,
        ...rest
    }) => ({
        label, value,
        ...rest
    }));

    const getMuskPattern = (name) =>
        name === 'businessPhone' ? '(999) 999 9999' : 'a9a 9a9'

    // Validation function to check if required fields are filled and have no errors
    const isFormValid = () => {
        // Check required fields have data
        const hasSubCategories = information?.subCategory && information.subCategory.length > 0;
        const hasCity = information?.city && information.city.trim() !== '';
        const hasPostalCode = information?.postalCode && information.postalCode.trim() !== '';
        const hasStreet = information?.street && information.street.trim() !== '';

        // If subcategories are selected, don't consider subCategory error
        const hasSubCategoryError = hasSubCategories ? false : (formError["subCategory"] && formError["subCategory"] !== "");
        
        // Check for actual validation errors (not just empty field warnings)
        const hasCityError = formError["city"] && formError["city"] !== "" && formError["city"] !== "req";
        const hasPostalCodeError = formError["postalCode"] && formError["postalCode"] !== "" && formError["postalCode"] !== "req";
        const hasBusinessNameError = formError["businessName"] && formError["businessName"] !== "" && formError["businessName"] !== "req";
        const hasLicenseNoError = formError["licenseNo"] && formError["licenseNo"] !== "" && formError["licenseNo"] !== "req";
        const hasStreetError = formError["street"] && formError["street"] !== "" && formError["street"] !== "req";
        const hasBusinessPhoneError = formError["businessPhone"] && formError["businessPhone"] !== "" && formError["businessPhone"] !== "req";
        const hasBusinessEmailError = formError["businessEmail"] && formError["businessEmail"] !== "" && formError["businessEmail"] !== "req";
        
        // ADD THIS: Check for website validation error
        const hasBusinessWebsiteError = formError["businessWebsite"] && formError["businessWebsite"] !== "" && formError["businessWebsite"] !== "req";
        
        // Return true only if all required fields are filled AND no format validation errors exist
        return hasSubCategories && hasCity && hasPostalCode && hasStreet &&
               !hasSubCategoryError && !hasCityError && !hasPostalCodeError &&
               !hasBusinessNameError && !hasLicenseNoError && !hasStreetError &&
               !hasBusinessPhoneError && !hasBusinessEmailError && 
               !hasBusinessWebsiteError; // ADD THIS LINE
    };
    

    return (
        <>
            {specialInfoDetails?.length ?

                <div className="myaccountsection institutedetails">
                    <>
                        <div className="leftsightbackdetails listofofferleft ">
                            <h3 className="h3_style">{t("expertDashboard.Specialization_Information")}</h3>
                        </div>
                        {!editSpecial ?
                            <>
                                {specialInfoDetails.map((item, i) => (
                                    <div className="form-field speciallinfobox" key={i}>
                                    <div className="accbtn">    
                                        <button type="button" className="myadbtn absolutedown" onClick={() => { changeSpecialState(true); getSpecialization(item) }}><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.4597 5.8743L13.8341 4.49994L13.8341 4.49992C14.0686 4.26543 14.1858 4.14818 14.2703 4.03599C14.8063 3.32377 14.8063 2.34278 14.2703 1.63057C14.1858 1.51837 14.0686 1.40112 13.8341 1.16663L13.8341 1.16661L13.8341 1.16658C13.5996 0.932098 13.4823 0.814852 13.3701 0.730405C12.6579 0.194357 11.6769 0.194357 10.9647 0.730405C10.8525 0.814852 10.7353 0.932097 10.5008 1.16658L10.5007 1.16661L9.10713 2.56023C9.90404 3.94047 11.0608 5.08825 12.4597 5.8743ZM7.65253 4.01482L2.19046 9.4769C1.7654 9.90196 1.55287 10.1145 1.41314 10.3756C1.2734 10.6367 1.21446 10.9314 1.09657 11.5209L0.647836 13.7645C0.581314 14.0971 0.548053 14.2634 0.642661 14.358C0.737269 14.4526 0.903573 14.4194 1.23618 14.3529H1.23618L3.47983 13.9041C4.06928 13.7862 4.36401 13.7273 4.62511 13.5876C4.8862 13.4478 5.09873 13.2353 5.52379 12.8102L11.0014 7.33267C9.65352 6.48191 8.51135 5.34748 7.65253 4.01482Z" fill="white" />
                                        </svg></button>
                                        <button type="button" className="myadbtn absoluteup" onClick={() => onDeleteButtonClick(item?.expertSpecializationId)}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
  <path d="M6.5625 3.1254V1.06152C6.5625 0.879187 6.63493 0.704319 6.76386 0.575388C6.8928 0.446456 7.06766 0.374023 7.25 0.374023H12.75C12.9323 0.374023 13.1072 0.446456 13.2361 0.575388C13.3651 0.704319 13.4375 0.879187 13.4375 1.06152V3.1254H18.9375C19.1198 3.1254 19.2947 3.19783 19.4236 3.32676C19.5526 3.45569 19.625 3.63056 19.625 3.8129C19.625 3.99523 19.5526 4.1701 19.4236 4.29903C19.2947 4.42797 19.1198 4.5004 18.9375 4.5004H1.0625C0.880164 4.5004 0.705295 4.42797 0.576364 4.29903C0.447433 4.1701 0.375 3.99523 0.375 3.8129C0.375 3.63056 0.447433 3.45569 0.576364 3.32676C0.705295 3.19783 0.880164 3.1254 1.0625 3.1254H6.5625ZM7.9375 3.1254H12.0625V1.7504H7.9375V3.1254ZM3.125 19.6254C2.94266 19.6254 2.7678 19.553 2.63886 19.424C2.50993 19.2951 2.4375 19.1202 2.4375 18.9379V4.5004H17.5625V18.9379C17.5625 19.1202 17.4901 19.2951 17.3611 19.424C17.2322 19.553 17.0573 19.6254 16.875 19.6254H3.125ZM7.9375 15.5004C8.11984 15.5004 8.2947 15.428 8.42364 15.299C8.55257 15.1701 8.625 14.9952 8.625 14.8129V7.9379C8.625 7.75556 8.55257 7.58069 8.42364 7.45176C8.2947 7.32283 8.11984 7.2504 7.9375 7.2504C7.75516 7.2504 7.5803 7.32283 7.45136 7.45176C7.32243 7.58069 7.25 7.75556 7.25 7.9379V14.8129C7.25 14.9952 7.32243 15.1701 7.45136 15.299C7.5803 15.428 7.75516 15.5004 7.9375 15.5004ZM12.0625 15.5004C12.2448 15.5004 12.4197 15.428 12.5486 15.299C12.6776 15.1701 12.75 14.9952 12.75 14.8129V7.9379C12.75 7.75556 12.6776 7.58069 12.5486 7.45176C12.4197 7.32283 12.2448 7.2504 12.0625 7.2504C11.8802 7.2504 11.7053 7.32283 11.5764 7.45176C11.4474 7.58069 11.375 7.75556 11.375 7.9379V14.8129C11.375 14.9952 11.4474 15.1701 11.5764 15.299C11.7053 15.428 11.8802 15.5004 12.0625 15.5004Z" fill="white"/>
</svg>
                                        </button>
                                        </div>
                                        <div className="disgrid grid-2 mobdisgrid">
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Name_Institution")}*</label><div className="fieldans">{item?.institute?.name}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Category_pecialization")}*</label><div className="fieldans">{item?.parentInstitutionCategory}</div></div>
                                        </div>
                                        <div className="form-fieldinner mt-3"><label>{t("expertDashboard.Sub_Categories")}*</label><div className="fieldans d-flex">
                                            {item?.expertSpecializationSubCategories?.map((item1, j) => (
                                                <span key={j}>{item1?.subInstitutionCategory?.name}</span>
                                            ))}
                                        </div></div>
                                        <hr></hr>
                                        <div className="disgrid grid-2">
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Business_Name")}</label><div className="fieldans">{item?.businessName}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Business_License")}*</label><div className="fieldans">{item?.businessLicenseNumber}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Business_Phone")}</label><div className="fieldans">{item.businessPhoneNumber && formatCanadianPhoneNumber(item?.businessPhoneNumber)}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Business_E-mail_Address")}</label><div className="fieldans">{item?.businessEmail}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Business_Website")}</label><div className="fieldans">{item?.businessWebsite}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Years_Experience")}</label><div className="fieldans">{item?.experienceInYears}</div></div>
                                        </div>
                                        <hr></hr>
                                        <div className="form-fieldinner mb-3"><label>{t("expertDashboard.Street_Address")}*</label><div className="fieldans">{item?.address}</div></div>
                                        <div className="disgrid grid-2">
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Postal_Code")}*</label><div className="fieldans">{item?.postalCode}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Provience")}* </label><div className="fieldans">{item?.state?.name}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.City")}*</label><div className="fieldans">{item?.city}</div></div>
                                            <div className="form-fieldinner"><label>{t("expertDashboard.Country")}*</label><div className="fieldans">{item?.country?.name}</div></div>
                                           
                                        </div>
                                    </div>
                                ))}
                            </> : null}

                        {editSpecial ? <div className="myaccountsection institutedetails">
                            <div className="myaccountsectionheading">
                                <div className="mybtn">
                                    <button type="button" className="myadbtn adptp" onClick={() => changeSpecialState(false)}>
                                    <img src={cross} alt='close'/>
                                    </button>
                                </div>
                            </div>

                            <div className="disgrid grid-2">
                                <div className="input-container form-group">
                                    <label className="placeholder">{t("expertDashboard.Name_Institution")}*</label>
                                    <input type="text" disabled className={
                                        isRequired && formError["institutionName"]
                                            ? "input form-control  is-invalid"
                                            : "input form-control"
                                    } name="institutionName" placeholder=" " value={information.institutionName} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                    <span className="text-danger">
                                        {isRequired &&
                                            formError["institutionName"] &&
                                            (formError["institutionName"] === "req"
                                                ? "institutionName is required!"
                                                : "Please enter a proper institutionName!")}
                                    </span>
                                </div>
                                <div className="input-container form-group">
                                    <label className="placeholder">{t("expertDashboard.Category_pecialization")}*</label>
                                    <input type="text" disabled className={
                                        isRequired && formError["institutionCategory"]
                                            ? "input form-control  is-invalid"
                                            : "input form-control"
                                    } name="institutionCategory" placeholder=" " value={information.institutionCategory} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                    <span className="text-danger">
                                        {isRequired &&
                                            formError["institutionCategory"] &&
                                            (formError["institutionCategory"] === "req"
                                                ? "institutionCategory is required!"
                                                : "Please enter a proper institutionCategory!")}
                                    </span>
                                </div>
                            </div>
                            
                            <div className="disgrid grid-0">
                            <label className={`placeholder`}>{t("expertDashboard.Sub_Categories")}*</label>
                                <Select className={`mb-4 form-container form-group multiselect ${
                                    isRequired && formError["subCategory"] ? "is-invalid" : ""
                                }`}
                                    closeMenuOnSelect={false}
                                    classNamePrefix="multicustomselect"
                                    isMulti
                                    options={newArrayOfObj}
                                    onChange={(e) => handleChange(e, 'subCategory')}
                                    value={information['subCategory']}
                                    components={{
                                        Input: (props) => {
                                            //const { value } = props

                                            return <>
                                                {/* <label className={`placeholder ${(wholeData['subCategory']?.length > 0 || value !== '') ? 'active' : ''}`}>Sub-Categories*
                                                    {<span className="plantooltip custooltip" title="" > <div className="tooltipcontent">Sub-Categories</div></span>}
                                                </label> */}

                                                <components.Input {...props} className={"mb-4 input-container form-group"} >
                                                    {props.children}
                                                </components.Input>
                                            </>
                                        },
                                        Option: (props) => {
                                            const { isSelected } = props

                                            return (
                                                <div>
                                                    <components.Option {...props}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => null}
                                                        />
                                                        {props.children}
                                                    </components.Option>
                                                </div>
                                            );
                                        }
                                    }}
                                />
                                
                            </div>
                            
                            <hr></hr>

                            <div className="form-fieldinner">
                                <div className="disgrid grid-2">
                                    <div className="input-container form-group">
                                        <label className="placeholder">{t("expertDashboard.Business_Name")}*</label>
                                        <input type="text" className={
                                            isRequired && formError["businessName"]
                                                ? "input form-control  is-invalid"
                                                : "input form-control"
                                        } placeholder=" " name="businessName" maxLength={50}
                                            value={information?.businessName}
                                            onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                        <span className="text-danger">
                                            {isRequired &&
                                                formError["businessName"] &&
                                                (formError["businessName"] === "req"
                                                    ? "businessName is required!"
                                                    : "Please enter a proper businessName!")}
                                        </span>
                                    </div>
                                    <div className="input-container form-group">
                                        <label className="placeholder">{t("expertDashboard.Business_License")}*</label>
                                        <input type="text" className={
                                            isRequired && formError["licenseNo"]
                                                ? "input form-control  is-invalid"
                                                : "input form-control"
                                        } placeholder=" " name="licenseNo" maxLength={50}
                                            value={information?.licenseNo}
                                            onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                        <span className="text-danger">
                                            {isRequired &&
                                                formError["licenseNo"] &&
                                                (formError["licenseNo"] === "req"
                                                    ? "License No is required!"
                                                    : "Please enter a proper License No!")}
                                        </span>
                                    </div>
                                </div>
                                <div className="disgrid grid-2">
                                    <div className="form-fieldinner"><label className="placeholder">{t("expertDashboard.Business_Phone")} </label>
                                        <div className="input-container form-group">

                                            <InputMask mask={getMuskPattern('businessPhone')} name="businessPhone" value={information?.businessPhone} onChange={onInputChangeHandler} onBlur={onTouchHandler}>
                                                {(inputProps) => <input {...inputProps} type="tel" className={
                                                    isRequired && formError["businessPhone"]
                                                        ? "input form-control  is-invalid"
                                                        : "input form-control"
                                                } placeholder=" " disableUnderline />}
                                            </InputMask>
                                           

                                            <span className="text-danger">
                                                {isRequired &&
                                                    formError["businessPhone"] &&
                                                    (formError["businessPhone"] === "req"
                                                        ? " Institute Contact Number is required!"
                                                        : "Please enter a proper  Institute Contact Number!")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-fieldinner">
                                        <div className="input-container form-group"><label className="placeholder">{t("expertDashboard.Business_E-mail_Address")}</label>
                                            <input type="text" className={
                                                isRequired && formError["businessEmail"]
                                                    ? "input form-control  is-invalid"
                                                    : "input form-control"
                                            } name="businessEmail" placeholder=" " value={information.businessEmail} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                            <span className="text-danger">
                                                {isRequired &&
                                                    formError["businessEmail"] &&
                                                    (formError["businessEmail"] === "req"
                                                        ? "businessEmail is required!"
                                                        : "Please enter a proper businessEmail!")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="disgrid grid-2">
                                    <div className="form-fieldinner">
                                        <div className="input-container form-group"><label className="placeholder">{t("expertDashboard.Business_Website")}</label>
                                            <input type="text" className={
                                                isRequired && formError["businessWebsite"]
                                                    ? "input form-control  is-invalid"
                                                    : "input form-control"
                                            } name="businessWebsite" placeholder=" " value={information.businessWebsite} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                            <span className="text-danger">
                                                {isRequired &&
                                                    formError["businessWebsite"] &&
                                                    (formError["businessWebsite"] === "req"
                                                        ? "businessWebsite is required!"
                                                        : "Please enter a proper businessWebsite!")}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-fieldinner">
                                        <div className="input-container form-group">  <label className="placeholder">{t("expertDashboard.Years_Experience")}</label>
                                            <input type="number" className={
                                                isRequired && formError["yearsOfEperience"]
                                                    ? "input form-control  is-invalid"
                                                    : "input form-control"
                                            } name="yearsOfEperience" placeholder=" " value={information.yearsOfEperience} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                            <span className="text-danger">
                                                {isRequired &&
                                                    formError["yearsOfEperience"] &&
                                                    (formError["yearsOfEperience"] === "req"
                                                        ? "yearsOfEperience is required!"
                                                        : "Please enter a proper yearsOfEperience!")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr></hr>

                            <div className="form-fieldinner">
                                <div className="input-container form-group"><label className="placeholder">{t("expertDashboard.Street_Address")}* </label>
                                    <input type="text" className={
                                        isRequired && formError["street"]
                                            ? "input form-control  is-invalid"
                                            : "input form-control"
                                    } placeholder=" " name="street" maxLength={100} value={information?.street} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                    <span className="text-danger">
                                        {isRequired &&
                                            formError["street"] &&
                                            (formError["street"] === "req"
                                                ? "street is required!"
                                                : "Please enter a proper street!")}
                                    </span>
                                </div>
                            </div>
                            <div className="disgrid grid-2">
                            <div className="form-fieldinner">
                                    <div className="input-container form-group">  <label className="placeholder">{t("expertDashboard.Postal_Code")}*</label>

                                        <InputMask mask={getMuskPattern('postalCode')} name="postalCode" value={information?.postalCode} onChange={onInputChangeHandler} onBlur={onTouchHandler}>
                                            {(inputProps) => <input {...inputProps} type="tel" className={
                                                isRequired && (formError["postalCode"] || (!information?.postalCode || information.postalCode.trim() === ''))
                                                    ? "input form-control  is-invalid"
                                                    : "input form-control"
                                            } placeholder=" " disableUnderline />}
                                        </InputMask>
                                       

                                        <span className="text-danger">
                                            {isRequired &&
                                                (formError["postalCode"] || (!information?.postalCode || information.postalCode.trim() === '')) &&
                                                (formError["postalCode"] === "req" || !information?.postalCode
                                                    ? "Postal Code is required!"
                                                    : "Please enter a proper postal code!")}
                                        </span>
                                    </div>
                                </div>
                                <div className="form-fieldinner">
                                    <div className="input-container form-group">
                                        <div className="placeholder">{t("expertDashboard.Provience")}*</div>
                                        <Select className={`selectbox`}
                                            name="province"
                                            closeMenuOnSelect={true}
                                            placeholder={" "}
                                            options={provinceList}
                                            onChange={(e) => handleChange(e, 'province')}
                                            value={provinceList.filter(ite => ite.value === information?.province)}
                                        />
                                    </div>
                                </div>
                                <div className="form-fieldinner">
                                    <div className="input-container form-group"><label className="placeholder">{t("expertDashboard.City")}*</label>
                                        <input type="text" className={
                                            isRequired && (formError["city"] || (!information?.city || information.city.trim() === ''))
                                                ? "input form-control  is-invalid"
                                                : "input form-control"
                                        } placeholder=" " name="city" maxLength={50} value={information?.city} onChange={onInputChangeHandler} onBlur={onTouchHandler} />

                                        <span className="text-danger">
                                            {isRequired &&
                                                (formError["city"] || (!information?.city || information.city.trim() === '')) &&
                                                (formError["city"] === "req" || !information?.city
                                                    ? "City is required!"
                                                    : "Please enter a proper city!")}
                                        </span>
                                    </div>
                                </div>
                               
                                <div className="form-fieldinner">
                                    <div className="input-container form-group"> <div className="placeholder">{t("expertDashboard.Country")}*</div>
                                        <Select className={`selectbox`}
                                            closeMenuOnSelect={true}
                                            placeholder={" "}
                                            name="country"
                                            options={countryList}
                                            onChange={(e) => handleChange(e, 'country')}
                                            value={countryList.filter(ite => ite.value === information?.country)}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <button 
                                type="button" 
                                className={`ctaonebutton widthhalf ${!isFormValid() ? 'disabled' : ''}`}
                                onClick={() => onOthersButtonClick()}
                                disabled={!isFormValid()}
                                style={{
                                    opacity: !isFormValid() ? 0.6 : 1,
                                    cursor: !isFormValid() ? 'not-allowed' : 'pointer'
                                }}
                            >
                                Save
                            </button>
                        </div> : null}
                    </>
                </div>
                : null
            }
        </>
    );
};

export default ViewSpecialInfoJSX;